<!-- 確認番号 -->
<template>
  <div class="row">
    <div class="th cell">確認番号</div>
    <div class="cell">{{ num }}</div>
  </div>
</template>

<script>
export default {
  name: "StoreConfirmationNumber",
  props: {
    num: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.row {
  display: table-row;
}

.cell {
  font-weight: bold;
  display: table-cell;
  padding: 8px;
}
.th {
  font-weight: 100;
  padding-right: 14px;
  color: grey;
  padding-right: 14px;
}
</style>
